import type { PContainer, PImage } from '../../../engine/aliases'
import { common } from '../../../main/common-sidecar'
import { ShaderHighlightPipeline2 } from '../../../pipeline/ShaderHighlightPipeline2'

import { sprites } from '../../../sprites/sprites-sidecar'
import { spritesUtil } from '../../../sprites/spritesUtil-sidecar'
import { chessLayers } from '../chessLayers-sidecar'

const enabled = false
interface IChessShaderTestData {
  images: PImage[]
}
let _obj: IChessShaderTestData | null = null

export function getRenderer() {
  let gm = common.getPhaserScene().game
  let renderer = gm.renderer as Phaser.Renderer.WebGL.WebGLRenderer
  return renderer
}
export function installShaders() {
  let gm = common.getPhaserScene().game
  let renderer = getRenderer()
  renderer.pipelines.add(
    ShaderHighlightPipeline2.KEY,
    new ShaderHighlightPipeline2(gm),
  )
}
export function getShader(key: string) {
  let renderer = getRenderer()
  const pipeline = renderer.pipelines.get(key)
  return pipeline
}

export function create() {
  if (!enabled) {
    return
  }
  get(chessLayers.getLayers().uiGame)
}

export const get = (layer: PContainer) => {
  if (!_obj) {
    let images: PImage[] = []

    let image = spritesUtil.createImage(layer, sprites.chessBishopWhite[0])
    image.x = 400
    image.y = 400

    let pipeline = getShader(ShaderHighlightPipeline2.KEY)
    image.setPipeline(pipeline)
    image.scale = 1

    pipeline.set2fv('uUvCenter', [
      (image.frame.u0 + image.frame.u1) / 2.0,
      (image.frame.v0 + image.frame.v1) / 2.0,
    ])

    images.push(image)

    _obj = {
      images,
    }
  }
  return _obj
}

export const update = () => {
  // let d = getData()
}
